import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "has-first-letter-uppercase has-text-success is-size-5" }
const _hoisted_2 = { class: "columns my-3" }
const _hoisted_3 = { class: "column is-5" }
const _hoisted_4 = { class: "column is-7" }
const _hoisted_5 = { class: "has-text-grey is-italic" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item_gi = _resolveComponent("n-form-item-gi")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_color_picker = _resolveComponent("n-color-picker")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_AQMap = _resolveComponent("AQMap")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    ref: "modal",
    width: "60vw"
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('station_list.edit.title')), 1 /* TEXT */)
    ]),
    body: _withCtx(() => [
      (_ctx.failed)
        ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            title: _ctx.$t('station_list.edit.failure'),
            type: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.try_again')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_n_form, {
            ref: "formInst",
            model: _ctx.result,
            "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.result) = $event)),
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_grid, {
                "x-gap": 5,
                "y-gap": 5,
                cols: 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_form_item_gi, {
                    span: 2,
                    label: _ctx.$t('station_list.edit.field_name'),
                    path: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.result.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.result.name) = $event)),
                        clearable: "",
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 2,
                    label: _ctx.$t('station_list.edit.field_room'),
                    path: "room"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.result.room,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result.room) = $event)),
                        clearable: "",
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 2,
                    label: _ctx.$t('station_list.edit.field_city'),
                    path: "city"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.result.city,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.result.city) = $event)),
                        clearable: "",
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_latitude'),
                    path: "lat"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input_number, {
                        value: _ctx.result.lat,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.result.lat) = $event)),
                        min: -90,
                        max: 90,
                        "show-button": false,
                        clearable: "",
                        style: {"width":"100%"},
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_longitude'),
                    path: "lon"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input_number, {
                        value: _ctx.result.lon,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.result.lon) = $event)),
                        min: -180,
                        max: 180,
                        "show-button": false,
                        clearable: "",
                        width: "100%",
                        style: {"width":"100%"},
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 2,
                    label: _ctx.$t('station_list.edit.field_color'),
                    path: "lon"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_color_picker, {
                        value: _ctx.result.color,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.result.color) = $event)),
                        clearable: "",
                        width: "100%"
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('station_list.edit.click_to_set_position')), 1 /* TEXT */),
          _createVNode(_component_AQMap, {
            "onAqmap:dblclick": _cache[7] || (_cache[7] = ($event: any) => (_ctx.onMapClick($event))),
            stations: [_ctx.mapStation]
          }, null, 8 /* PROPS */, ["stations"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "button is-light mr-2",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.close(false)))
      }, _toDisplayString(_ctx.$t('global.cancel')), 1 /* TEXT */),
      _createElementVNode("button", {
        class: "button is-success",
        disabled: !_ctx.valid || _ctx.pristine,
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, _toDisplayString(_ctx.$t('global.ok')), 9 /* TEXT, PROPS */, _hoisted_6)
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}